import { render, staticRenderFns } from "./TaskViewDetail.vue?vue&type=template&id=1dd00952&scoped=true"
import script from "./TaskViewDetail.vue?vue&type=script&lang=js"
export * from "./TaskViewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd00952",
  null
  
)

export default component.exports